var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-payment",on:{"click":function($event){return _vm.$emit('click')}}},[_c('plus-icon',{staticClass:"icon",attrs:{"fill":"currentColor"}}),_c('span',[_vm._v("Add credit card")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }